/**
 * Test ID constants for data-testid attributes.
 *
 * Naming convention:  {BASE}-{PAGE}-{SECTION}-{ELEMENT}
 *   e.g. "communication-home-actions-export-label"
 *
 * All elements in this app share the same base prefix because the entire
 * application is the Communication module.
 */

// -- Base --------------------------------------------------------------------
/** Root prefix shared by every test ID in the application */
export const TEST_ID_BASE = 'communication' as const

// -- Pages -------------------------------------------------------------------
/** Page-level identifiers (second segment) */
export const TestIdPage = {
    HOME: 'home',
    DETAIL: 'detail',
    NEW: 'new',
    CAMPAIGNS: 'campaigns',
    NAV: 'nav',
    NOT_FOUND: 'not-found',
    ACCESS_DENIED: 'access-denied',
} as const

// -- Sections ----------------------------------------------------------------
/** Section-level identifiers (third segment) */
export const TestIdSection = {
    HEADER: 'header',
    ACTIONS: 'actions',
    SEARCH: 'search',
    TABLE: 'table',
    FORM: 'form',
    MODAL: 'modal',
    PAGINATION: 'pagination',
    SIDEBAR: 'sidebar',
    SUMMARY: 'summary',
    TRIGGERS: 'triggers',
    TEMPLATES: 'templates',
    OUTPUT: 'output',
    CONTACTS: 'contacts',
} as const
